import { createContext, useContext } from 'react'
import { ToastContainer, toast } from 'react-toastify'
import ClassNames from 'classnames'

import { config } from '../../../components/Init/Init'
import { NotificationCloseButton } from './NotificationCloseButton'
import { NotificationMessage } from './NotificationMessage'

import classes from './styles/notification.module.scss'

const NotificationContext = createContext()
NotificationContext.displayName = 'NotificationContext'

export const useNotification = () => useContext(NotificationContext)

export const NotificationProvider = ({ children }) => {
  const notificationDefaultOptions = {
    type: config.notificationConfigs.types.default,
    icon: false,
    toastId: null,
    onClose: () => {}
  }

  const showNotification = (message, options) => {
    const notificationOptions = { ...notificationDefaultOptions, ...options }

    const notificationClassName = ClassNames(classes.notification, {
      [classes.notification__success]: notificationOptions.type === config.notificationConfigs.types.success,
      [classes.notification__info]: notificationOptions.type === config.notificationConfigs.types.info,
      [classes.notification__warning]: notificationOptions.type === config.notificationConfigs.types.warning,
      [classes.notification__error]: notificationOptions.type === config.notificationConfigs.types.error
    })

    const progressBarClassName = ClassNames(classes.notificationProgressBar, {
      [classes.notificationProgressBar__success]: notificationOptions.type === config.notificationConfigs.types.success,
      [classes.notificationProgressBar__info]: notificationOptions.type === config.notificationConfigs.types.info,
      [classes.notificationProgressBar__warning]: notificationOptions.type === config.notificationConfigs.types.warning,
      [classes.notificationProgressBar__error]: notificationOptions.type === config.notificationConfigs.types.error
    })

    if (config.enableToutsNotification && message && !toast.isActive(notificationOptions.toastId)) {
      toast(<NotificationMessage message={message} options={options} />, {
        className: notificationClassName,
        progressClassName: progressBarClassName,
        onClose: notificationOptions.onClose,
        toastId: options.toastId
      })
    }
  }

  return (
    <NotificationContext.Provider value={{ showNotification }}>
      {children}
      <ToastContainer
        pauseOnHover
        autoClose={config.notificationCloseTimout}
        closeButton={NotificationCloseButton}
        limit={config.notificationDisplayLimit}
        className={classes.notificationContainer}
      />
    </NotificationContext.Provider>
  )
}
